import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { Colors } from '../../constants';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import { hex_to_rgba } from '../../custom_functions/hex_to_rgba';

const TimingList = (props) => {
  const {
    handleTimeClicked,
    dateSelected,
    timezoneName,
    timingsData,
    timingKey,
    color,
    handleConfirmButton,
    nextShowForm,
    isoTime,
    isShareDateTime,
    shareTimings
  } = props;

  const [ elements, setElements ] = useState(null);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ dateSelectedFormat, setDateSelectedFormat ] = useState(null);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    if(width <= 858){
      handleConfirmButton(true);
    }
  },
  // eslint-disable-next-line
  [width]);

  useEffect(() => {
    if(isLoading && Object.keys(timingsData).length > 0 && timingKey){
      let array_of_elements = [];
      let timings = timingsData[timingKey].filter( timing => moment(timing).tz(timezoneName).format('D M YYYY') === ( moment(dateSelected).tz(timezoneName).format('D M YYYY') ) )
      if(timings.length > 0){
        timings.forEach((time, index) => {
          array_of_elements.push(
            <Time
              key={index}
              handleTimeClicked={handleTimeClicked}
              nextShowForm={nextShowForm}
              time={time}
              timezoneName={timezoneName}
              color={color}
              isoTime={isoTime}
              isShareDateTime={isShareDateTime}
              shareTimings={shareTimings} />
          );
        });
        setElements(array_of_elements);
        setIsLoading(false);
      }
    }
  }, 
  // eslint-disable-next-line
  [isLoading, elements]);

  useEffect(() => {
    if(dateSelected && timingKey && timingsData && timingsData[timingKey]){
      setIsLoading(true); 
      
      let date_selected = `${t(moment(dateSelected).tz(timezoneName).format('dddd'))}, ${t(moment(dateSelected).tz(timezoneName).format('MMMM'))} ${moment(dateSelected).tz(timezoneName).format('DD')}`;

      setDateSelectedFormat(date_selected);
    }
  }, 
  // eslint-disable-next-line
  [dateSelected, timingKey, timingsData]);

  // if(isLoading) return (
  //   <div className="info">
  //     {t('Loading')}
  //   </div>
  // );
 
  // if(!elements) return(
  //   <div className="info">
  //     {t('Sorry, there are no available time slots for this date')}
  //   </div>
  // );

  return(
    <>
      <div className="timing-list-wrap">
        { isLoading && (
          <div className="info">
            {t('Loading')}
          </div>
        )}

        { !isLoading && !elements && (
          <div className="info">
            {t('Sorry, there are no available time slots for this date')}
          </div>
        )}

        { !isLoading && elements && (
          <div className="timing-list-inner">
            <div className="date-selected-header">
              { dateSelectedFormat }
            </div>
            <div className="timing-list">
              {elements}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const Time = (props) => {
  const [ bgColor, setBgColor ] = useState(`#${Colors.white}`);
  const [ borderColor, setBorderColor ] = useState(`#${Colors.white}`);
  const [ fontColor, setFontColor ] = useState(`${Colors.lightGray2}`);
  const [ customColor, setCustomColor ] = useState(`#${Colors.primaryColor}`);

  const [ bgColorConfirm, setBgColorConfirm ] = useState(`#${Colors.primaryColor}`);
  const [ borderColorConfirm, setBorderColorConfirm ] = useState(`#${Colors.primaryColor}`);
  const [ fontColorConfirm, setFontColorConfirm ] = useState(`${Colors.white}`);

  const [ confirmVisibility ] = useState('none');
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [ isSelected, setIsSelected ] = useState(false);

  const {
    handleTimeClicked,
    time,
    timezoneName,
    color,
    nextShowForm,
    isoTime,
    isShareDateTime,
    shareTimings
  } = props;

  useEffect(() => {
    if(props){
      setCustomColor(props.color);

      setBgColorConfirm(props.color);
      setBorderColorConfirm(props.color);
    }
  }, [props]);

  useEffect(() => {
    if (isShareDateTime && time && Object.keys(shareTimings).length > 0) {
      var current_date_time = new Date(time);
      var key = `${current_date_time.getDate()}-${("0" + (current_date_time.getMonth() + 1)).slice(-2)}-${current_date_time.getFullYear()}`;
      if (shareTimings[key] && shareTimings[key].includes(time)) {
        setBgColor(`${hex_to_rgba(color, 0.15)}`);
        setBorderColor(`${color}`);
        setFontColor(`${color}`);
        setIsSelected(true);
      }
    }
  },
  // eslint-disable-next-line
  [isShareDateTime, time, shareTimings, color]);

  const onMouseOver = (e)=>{
    // check if the target element is the selected date
    if(e.target.classList.contains('time-selected')){
      setBgColor(`${hex_to_rgba(color, 0.15)}`);
      setBorderColor(`${hex_to_rgba(color, 0.15)}`);
      setFontColor(`${color}`);
    }
    else{
      setBgColor(`#${Colors.white}`);
      setBorderColor(`${customColor}`);
      setFontColor(`${customColor}`);
    }
  };

  const onMouseOut=(e)=>{
    // check if the target element is the selected date
    if(e.target.classList.contains('time-selected')){
      setBgColor(`${hex_to_rgba(color, 0.15)}`);
      setBorderColor(`${hex_to_rgba(color, 0.15)}`);
      setFontColor(`${color}`)
    }
    else{
      setCustomColor(color);
      setBgColor(`#${Colors.white}`);
      setFontColor(`${Colors.lightGray2}`);
      setBorderColor(`#${Colors.white}`);
    }
  };
  
  // handle button next confirm
  const onMouseOverConfirm = () => {
    setBgColorConfirm(`#${Colors.white}`);
    setFontColorConfirm(`${color}`);
    setBorderColorConfirm(`${color}`);
  };

  const onMouseOutConfirm = () => {
    setBgColorConfirm(`${color}`);
    setFontColorConfirm(`#${Colors.white}`);
    setBorderColorConfirm(`#${Colors.white}`);
  };

  // callback function to show next confirm button
  const handleConfirmTime = (time) => {
    // if not to share date and time
    if (!isShareDateTime) {
      // hide all button confirm
      var buttons = document.getElementsByClassName('time-confirm');
      for(let i=0; i<= buttons.length; i++){
        if(buttons[i]){
          buttons[i].style.display = 'none';
        }
      }

      if(width > 858){
        // show confirm button -> next button
        var element = document.getElementById(`confirm-time-${time}`);
        if(element){
          element.style.display = 'block';
        }
      }

      // remove time-selected class
      var times = document.getElementsByClassName('time');
      if(times.length > 0){
        for(let i=0; i<= times.length; i++){
          if(times[i]){
            times[i].classList.remove('time-selected');

            times[i].style.backgroundColor = `#${Colors.white}`;
            times[i].style.borderColor = `#${Colors.white}`;
            times[i].style.color = `${Colors.lightGray2}`;
          }
        }
      }

      // update styling for time selected
      

      if(width <= 858){
        // set timing
        handleTimeClicked(time);
      }
    } else {
      // add class time-selected
      handleTimeClicked(time)
    }

    // add class time-selected
    var time_selected = document.getElementById(`time-${time}`);
    if(time_selected){
      if (time_selected.classList.contains('time-selected')) {
        time_selected.classList.remove('time-selected');

        time_selected.style.backgroundColor = `#${Colors.white}`;
        time_selected.style.borderColor = `#${Colors.white}`;
        time_selected.style.color = `${Colors.lightGray2}`;
      } else {
        time_selected.classList.add('time-selected');
        time_selected.style.borderColor = color;
        time_selected.style.color = color;
        time_selected.style.backgroundColor = hex_to_rgba(color, 0.15);
      }
    }
  };

  // callback function when user click confirm button (next)
  const confirmOnClick = (time) => {
    handleTimeClicked(time);
    nextShowForm();
  };

  return(
    <div className="time-wrap">
      <div 
        className={`time ${isSelected ? 'time-selected' : ''}`}
        data-id={time}
        id={`time-${time}`}
        style={{ color: fontColor, borderColor: borderColor, backgroundColor: bgColor }}
        onMouseEnter={(e) =>onMouseOver(e)} 
        onMouseLeave={(e) => onMouseOut(e)}
        onClick={()=>handleConfirmTime(time)}
        onTouchStart={()=>handleConfirmTime(time)} >
          {isoTime === true ? (moment(`${time}`,'x').tz(timezoneName).format("HH:mm")) : (moment(`${time}`,'x').tz(timezoneName).format("hh:mm a"))}
      </div>

      { width > 858 && (
        <div className="time-confirm" id={`confirm-time-${time}`} style={{ display: confirmVisibility }}>
          <button 
            className="btn-time-confirm"
            style={{ color: fontColorConfirm, background: bgColorConfirm, borderColor: borderColorConfirm }}
            onMouseEnter={() =>onMouseOverConfirm()} 
            onMouseLeave={() => onMouseOutConfirm()}
            onClick={()=>confirmOnClick(time)}
            onTouchStart={()=>confirmOnClick(time)} >
              {t('Next')}
            </button>
        </div>
      )}      
    </div>
  )
};

export default TimingList;